import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  IonLoading,
  IonRefresher,
  IonRefresherContent,
  useIonViewWillEnter,
} from '@ionic/react';
import { PageLayout } from 'containers/layout';
import ReceiptList from 'containers/receipts/ReceiptList';
import { AuthSelectors } from 'redux/AuthRedux';
import ReceiptActions, { ReceiptSelectors } from 'redux/ReceiptRedux';
import api_v2 from 'services/api_v2';

function ReceiptsPage() {
  const dispatch = useDispatch();
  const token = useSelector(AuthSelectors.selectToken);
  const receiptsLoading = useSelector(ReceiptSelectors.selectReceiptsLoading);

  const handleLoadVenues = async (e) => {
    const api = api_v2(token);

    try {
      const resp = await api.getClosedTicketSByUser();
      dispatch(ReceiptActions.setReceipts(resp));
    } catch (err) {
      console.log("get closed tickets by user error: ", err.message);
    }

    e.detail.complete();
  };

  useIonViewWillEnter(() => {
    dispatch(ReceiptActions.loadReceipts());
  });

  return (
    <PageLayout title="Receipts">
      <IonLoading isOpen={receiptsLoading} message="Loading..." />
      <IonRefresher slot="fixed" onIonRefresh={handleLoadVenues}>
        <IonRefresherContent />
      </IonRefresher>
      <ReceiptList />
    </PageLayout>
  );
}

export default ReceiptsPage;
